import React from 'react';
import { OutboundLink } from 'react-ga';

export default ({ link }) => {
  let target = '_self';
  if (link.blankTarget) {
    target = '_blank';
  }
  return (
    <OutboundLink
      to={link.url}
      target={target}
      eventLabel={link.url}
      className="line-lien"
    >
      <div className="title">
        <span>{link.name}</span>
      </div>
      <span className="action"><i className="ic ic-link"/></span>
    </OutboundLink>
  );
};



// WEBPACK FOOTER //
// ./book/src/links/LinkEntry.jsx